import React, { useRef } from "react";
import { Swiper as SwiperInstance } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { A11y, Parallax, Navigation } from "swiper/modules";

import "../../style.css";

export default function Carousel({
  children,
  numberOfItems,
  loop = false,
}: {
  children: React.ReactNode[];
  numberOfItems?: number;
  loop?: boolean;
}) {
  const divRef = useRef<HTMLDivElement>(null);
  const swiperRef = useRef<SwiperInstance | null>(null);

  // Swiper's loop mode requires enough slides; otherwise it warns and loop isn't reliable.
  const slideCount = children?.length ?? 0;
  const maxSlidesPerView = numberOfItems ?? 3;
  const safeLoop = loop && slideCount >= maxSlidesPerView * 2;

  const navigationPrevRef = React.useRef(null);
  const navigationNextRef = React.useRef(null);

  React.useEffect(() => {
    divRef.current?.focus();
  }, []);

  return (
    <div className="relative">
      <div className="px-1 md:px-12 relative">
        <Swiper
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          navigation={{
            // nextEl: ".swiper-button-next",
            // prevEl: ".swiper-button-prev",
            prevEl: navigationPrevRef.current,
            nextEl: navigationNextRef.current,
            enabled: true,
          }}
          autoplay={{
            delay: 5000,
            disableOnInteraction: true,
          }}
          // parallax={true}
          grabCursor={true}
          loop={safeLoop}
          mousewheel={true}
          pagination={{
            clickable: true,
          }}
          slidesPerView={1}
          spaceBetween={20}
          breakpoints={{
            320: {
              slidesPerView: 2.01,
              spaceBetween: 10,
            },
            640: {
              slidesPerView: 2,
              // spaceBetween: 20,
            },
            768: {
              slidesPerView: 2.2,
              // spaceBetween: 40,
            },
            850: {
              slidesPerView: 3.2,
              // spaceBetween: 40,
            },
            1200: {
              slidesPerView: numberOfItems ? numberOfItems : 3,
              // spaceBetween: 40,
            },
            3024: {
              slidesPerView: numberOfItems ? numberOfItems : 4,
              // spaceBetween: 50,
            },
          }}
          modules={[Navigation, Parallax, A11y]}
        >
          {children &&
            children.map((node, index) => {
              return <SwiperSlide key={index}>{node}</SwiperSlide>;
            })}
        </Swiper>
      </div>

      <div
        aria-disabled="false"
        ref={navigationNextRef}
        className="swiper-button-next border border-transparent !text-primary after:!text-xl after:md:!text-3xl after:!text-primary  after:content-['next']"
        onClick={() => swiperRef.current && swiperRef.current.slideNext()}
      ></div>
      <div
        aria-disabled="false"
        ref={navigationPrevRef}
        className="swiper-button-prev !text-primary after:!text-xl after:md:!text-3xl after:!text-primary after:content-['prev']"
        onClick={() => swiperRef.current && swiperRef.current.slidePrev()}
      ></div>
    </div>
  );
}
